import { Button, ButtonVariant, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { Col } from "@/components/customComponents";

interface IAnalyticsEmptyStateProps {
  title: string;
  description?: string;
  isError?: boolean;
  backLabel?: string;
  onBack?: () => void;
}

const AnalyticsEmptyState = ({ title, description, isError = false, backLabel, onBack }: IAnalyticsEmptyStateProps) => (
  <Col className="flex h-96 items-center justify-center gap-4">
    <Text variant={TextVariants.HEADING_6_BOLD} className={isError ? "text-red-500" : "text-default-400"}>
      {title}
    </Text>
    {description && (
      <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-default-400">
        {description}
      </Text>
    )}
    {onBack && backLabel && (
      <Button variant={ButtonVariant.SECONDARY} iconStart={IconVariants.ARROW_LEFT} onClick={onBack}>
        {backLabel}
      </Button>
    )}
  </Col>
);

export default AnalyticsEmptyState;
